export function resolveCssVar(cssVar: string) {
  if (cssVar.startsWith("var(")) {
    const varName = cssVar.match(/var\((--[^)]+)\)/)?.[1];
    if (varName) {
      return getComputedStyle(document.documentElement)
        .getPropertyValue(varName)
        .trim();
    }
  }
  return cssVar;
}
